import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Stats from "./components/Stats";
import PainPoints from "./components/PainPoints";
import PlanSelector from "./components/PlanSelector";
import Pricing from "./components/Pricing";
import Experience from "./components/Experience";
import Compliance from "./components/Compliance";
import CTA from "./components/CTA";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="bg-background-50 min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <PainPoints />
        <PlanSelector />
        <Pricing />
        <Experience />
        <Compliance />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}